module.exports = __webpack_public_path__ + "static/media/logo.bb4a5d21.svg";